import { Injectable } from '@angular/core';

import { Cacheable } from '../models/cacheable.model';
import { FileType } from '../models/file-item.model';
import { OperationStream } from '../models/operation-stream.model';
import { MruDataItem } from './mru-data-item.model';
import { MruDataServiceFactory } from './mru-data-service.factory';

/**
 * Format in which MRU data is returned back by MruDataService
 */
export interface MruData extends Cacheable {
    items: Array<MruDataItem>;
    impressionId: string;
}

export enum MruStorageHost {
    Unknown = 0,
    SkyDrive = 1,
    SkyDrivePro = 2,
    SharePointOnline = 3
}

@Injectable({
    providedIn: 'root',
    useFactory: (mruDataServiceFactory: MruDataServiceFactory) => mruDataServiceFactory.getMruService(),
    deps: [
        MruDataServiceFactory
    ]
})
export abstract class MruDataService {
    public abstract getMruDocuments(types?: Set<FileType>): OperationStream<MruData>;
    public abstract updateMruDocuments(types?: Set<FileType>): Promise<void>;
    public abstract removeDocument(item: MruDataItem): Promise<void>;
    public abstract updatePinnedState(item: MruDataItem): Promise<void>;
    public abstract writeMruDocument(item: MruDataItem): Promise<void>;
}
